import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import { schedulingApi } from "../../../../services/schedulingServices";
import { utils } from "../../../../utils/utils";
import Loader from "../../../Loader";

const SchedulingTab = () => {
  const { id: jobId } = useParams();
  const [loading, setLoading] = useState(true);
  const [scheduling, setScheduling] = useState(null);

  useEffect(() => {
    const fetchScheduling = async () => {
      setLoading(true);
      try {
        const data = await schedulingApi.getSchedulingByJobId(jobId);
        setScheduling(data);
      } catch (error) {
        console.error("Error fetching scheduling data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchScheduling();
  }, [jobId]);

  if (loading) {
    return <Loader />;
  }

  const schedulingFields = [
    { label: "Sequence Ship", value: scheduling?.sequenceShipDate },
    { label: "Back from OP", value: scheduling?.backFromOpDate },
    { label: "Fab Complete", value: scheduling?.fabCompleteDate },
    {
      label: "Processed / Kitted Need",
      value: scheduling?.processedKittedNeedDate,
    },
    { label: "Transmittal Need", value: scheduling?.transmittalNeedDate },
  ];

  return (
    <Col className="mt-3">
      <h3>Scheduling</h3>
      <Row className="mt-4">
        {schedulingFields.map((field, index) => (
          <Col md={6} key={index}>
            <FormGroup>
              <Label>{field.label}</Label>
              <Input
                type="text"
                readOnly
                value={field.value ? utils.formatDate(field.value) : "N/A"}
                className="bg-light"
              />
            </FormGroup>
          </Col>
        ))}
      </Row>
      {!scheduling && (
        <Row className="mt-2">
          <Col>
            <p className="text-muted">
              No scheduling data available for this job.
            </p>
          </Col>
        </Row>
      )}
    </Col>
  );
};

export default SchedulingTab;
